<template>
  <el-dialog
    :append-to-body="true"
    :visible="showDialog"
    :custom-class="
      `dialog-clear-style comment-gift-dialog${
        showDialog ? ' active-dialog' : ''
      }`
    "
    :show-close="true"
    @close="$emit('close')"
  >
    <div class="content-wrap" @click.stop>
      <div class="gift-title">{{ giftInfo && giftInfo.content }}</div>
      <img class="gift-img" :src="giftInfo && giftInfo.imageUrl" />
      <div class="price-count">
        <div class="price">
          <img src="~@/assets/image/icons/diamond.png" />
          <span>{{ giftInfo && giftInfo.paymentAmount * giftCount }}</span>
        </div>
        <InputNumber v-model="giftCount" :min="1" :max="1314" />
      </div>
      <button class="confirm-gift" @click="sendGift">確認</button>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import InputNumber from '@/components/common/input/input-number';
import goldImg from '@/assets/image/icons/diamond.png';
import Lottie from '@/components/SendGifts/components/lottie.js';
export default {
  components: {
    InputNumber
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    giftInfo: Object,
    orderInfo: Object,
    selectedGiftCount: Number
  },
  data() {
    return {
      giftCount: 1,
      showDialog: false
    };
  },
  computed: {
    ...mapGetters(['accountInfo', 'userInfo'])
  },
  watch: {
    show(flag) {
      this.showDialog = flag;
      if (flag) {
        document.body.style.overflow = 'hidden';
        this.addEvents();
      } else {
        document.body.style.overflow = 'auto';
      }
    },
    selectedGiftCount(count) {
      this.giftCount = count;
    }
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
  },
  methods: {
    addEvents() {
      this.$nextTick(() => {
        document.addEventListener('click', this.closeDialog);
        this.closeDom = document.querySelector(
          '.comment-gift-dialog.active-dialog .el-dialog__headerbtn'
        );
        this.closeDom.addEventListener('click', this.closeDialog);
      });
    },
    closeDialog() {
      this.$emit('change', false);
      document.removeEventListener('click', this.closeDialog);
      this.closeDom.removeEventListener('click', this.closeDialog);
    },
    sendGift() {
      window.fbq('track', 'InitiateCheckout');
      if (!this.userInfo || !this.accountInfo || !this.giftInfo) {
        this.$util.Login();
        return;
      }
      const { orderInfo } = this;
      const { playerUserUuid } = orderInfo;
      if (this.userInfo.uuid === playerUserUuid) {
        this.$message.error('不可以給自己送禮物喔');
        return;
      }
      if (this.isSending) {
        return;
      }
      const giftObj = this.giftInfo;
      let price = giftObj.paymentAmount * this.giftCount;
      if (this.accountInfo.diamondBalance < price) {
        this.$confirm({
          content: `当前餘額：<img class="gold-img" src="${goldImg}" />${this.accountInfo.diamondBalance}，請您到儲值頁面先儲值再送出禮物`,
          title: '賬戶餘額不足',
          confirmButtonText: '我要儲值',
          cancelButtonText: '取消',
          closeOnClickModal: true,
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.$router.push({
            name: 'Saving',
            params: {
              orderInfo,
              giftCount: this.giftCount,
              isCommentSendGift: true
            }
          });
        });
      } else {
        this.isSending = true;
        const { giftCount } = this;
        this.$http
          .post('/gift/send', {
            count: giftCount,
            giftId: giftObj.id,
            playerUserUuid
          })
          .then(() => {
            this.isSending = false;
            this.$store.dispatch('app/getUserAccount');
            this.giftCount = 1;
            this.$emit('change', false);
            if (location.href.includes('/chat/')) {
              Lottie({ giftId: giftObj.id, basePath: giftObj.animationUrl });
            } else {
              this.$util.openChatWindow(
                this.userInfo.uuid,
                playerUserUuid,
                '',
                {
                  giftId: giftObj.id,
                  basePath: giftObj.animationUrl
                }
              );
            }
            window.fbq('track', 'Purchase');
          })
          .catch(({ code }) => {
            this.isSending = false;
            switch (code) {
              case 801: {
                this.$message.error('您選擇的禮物不存在');
                break;
              }
              case 433: {
                this.$message.error('您的禮物已被拒絕接受');
                break;
              }
              case 701: {
                this.$message.error('您的余額不足，請先充值喔');
                this.$store.dispatch('app/getUserAccount');
                break;
              }
              case 430: {
                this.$message.error('用戶不存在');
                break;
              }
              default: {
                this.$message.error('禮物發送失敗');
                break;
              }
            }
          });
      }
    }
  }
};
</script>
<style lang="scss">
.comment-gift-dialog {
  .content-wrap {
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .gift-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      text-align: center;
      color: #333333;
    }
    .gift-img {
      height: 111px;
      margin-top: 30px;
    }
    .confirm-gift {
      margin-top: 30px;
      height: 44px;
      border-radius: 36px;
      width: 100%;
      @include button-yellow;
    }
  }
}

.price-count {
  width: 100%;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  .price {
    display: flex;
    align-items: center;
    img {
      width: 18px;
      margin-right: 5px;
    }
  }
  & /deep/ .input-number-wrap {
    display: flex;
    align-items: center;
    width: 138px;
    border: none;
    & > div {
      // top: 50%;
      // transform: translateY(-50%);
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #f2f2f2;
      box-sizing: border-box;
      border-radius: 8px;
      border: none;
      &::after,
      .vertical {
        background: #666666;
      }
      &::before {
        border: none;
      }
      &.disabled {
        opacity: 0.3;
        border-radius: 8px;
        border: 2px solid #dddddd;
      }
    }
    input {
      width: 52px;
      padding: 0;
      border: none;
      background: transparent;
    }
  }
}
.comment-gift-dialog {
  margin: 50vh 0 0 50vw !important;
  transform: translate(-50%, -50%);
  width: 418px;
  .el-dialog__headerbtn {
    right: 18px;
    top: 18px;
  }
  .content-wrap {
    width: 418px;
    margin: 0 auto;
    background: #ffffff;
    padding: 36px 20px 34px;
  }
  .price-count {
    padding: 0 53px;
  }
}
</style>
